import pick from 'lodash/pick';

import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const card_interaction: EventDefinition = {
  getData: (action, eventData = {}) => ({
    type: action,
    ...pick(eventData, ['view', 'label', 'cardType']),
  }),
  addContexts: ({ eventData } = {}) => {
    const customEntities = eventData?.entities ?? [];
    return createContexts(customEntities, { eventData });
  },
};
